<scaffold-dialog title="Select Service to Access" size="fit" [ngClass]="{'hidden': !visible}">
  <div scaffoldDialogBody>
    <app-scaffold-type [(selected)]="selectedValue" (optionsAvailable)="show($event)"></app-scaffold-type>
    </div>
    <div scaffoldDialogButtons>
      <button pButton severity="primary" (click)="close()">Select</button>
    </div>
</scaffold-dialog>
